import { Skeleton } from '@mui/material'
import clsx from 'clsx'
import { ClassName } from 'types/props'

import classes from './presentational-table.module.scss'

type Cell = string | number | React.ReactNode
type Row = Cell[]
type RowOption = {
  align?: string
  width?: string
}
interface Props extends ClassName {
  headerRow?: Row
  rowOptions: RowOption[]
  rows: Row[]
}
const getStyles = ({ index, rowOptions = [] }: { index: number; rowOptions: RowOption[] }) => {
  if (rowOptions.length === 0) return {}
  const options = rowOptions[index] || {}
  const { align, width } = options
  const styles: any = {}
  if (align) styles.textAlign = align
  if (width) styles.width = width
  return styles
}
export const PresentationalTable = ({ className, headerRow, rowOptions, rows }: Props) => (
  <table className={clsx(classes.root, className)}>
    {headerRow && (
      <thead>
        <tr className={classes.headerRow}>
          {headerRow.map((heading, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <th key={`${index}heading`} style={getStyles({ rowOptions, index })}>
              {heading}
            </th>
          ))}
        </tr>
      </thead>
    )}
    <tbody>
      {rows.map((row, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr key={`${i}row`}>
          {row.map((cell, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <td key={`${index}cell`} style={getStyles({ rowOptions, index })}>
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
)

interface LoadingProps extends ClassName {
  rowCount: number
  rowOptions: RowOption[]
}
export const LoadingPresentationalTable = ({ className, rowCount, rowOptions }: LoadingProps) => {
  const rows = new Array(rowCount).fill(new Array(rowOptions.length).fill(null))
  return (
    <table className={clsx(classes.root, className)}>
      <thead>
        <tr className={classes.headerRow}>
          {rows[0].map((cell, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <th key={`loading-header-row-${index}`} style={getStyles({ rowOptions, index })}>
              <Skeleton height="16px" width="120px" />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={`loading-row-${index}`}>
            {row.map((cell, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <td key={`loading-cell-${index}`} style={getStyles({ rowOptions, index })}>
                <Skeleton height="16px" width="80px" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
